import React from 'react';
import styled from '@grebban/style-system-react';

const Ol = styled('ol')`
    list-style-type: decimal;
    list-style-position: inside;
    margin-bottom: 1.6rem;

    ul,
    ol {
        list-style-position: inside;
        margin-left: 15px;
    }

    ul {
        list-style-type: circle;
    }

    ol {
        list-style-type: lower-latin;
    }
`;

interface OrderedListProps {
    children: React.ReactNode;
}

const OrderedList: React.FC<OrderedListProps> = ({ children }) => <Ol>{children}</Ol>;

export default OrderedList;
